import React from 'react';
import { withTheme } from 'styled-components';

const ArrowRightIcon = ({ theme }) => {
  return (
    <svg
      width="19"
      height="39"
      viewBox="0 0 19 39"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M3.13888 1.02381C2.59975 0.394824 1.6528 0.321982 1.02381 0.861115C0.394824 1.40025 0.321982 2.3472 0.861115 2.97619L3.13888 1.02381ZM17 19.5L18.1389 20.4762L18.9756 19.5L18.1389 18.5238L17 19.5ZM0.861115 36.0238C0.321982 36.6528 0.394824 37.5998 1.02381 38.1389C1.6528 38.678 2.59975 38.6052 3.13888 37.9762L0.861115 36.0238ZM0.861115 2.97619L15.8611 20.4762L18.1389 18.5238L3.13888 1.02381L0.861115 2.97619ZM3.13888 37.9762L18.1389 20.4762L15.8611 18.5238L0.861115 36.0238L3.13888 37.9762Z"
        fill={theme.themeColors.arrowButtons.color}
      />
    </svg>
  );
};

export default withTheme(ArrowRightIcon);
